import styled from 'styled-components';
import { CloseCircle } from '@styled-icons/ionicons-outline/CloseCircle';
import { CheckCircle } from '@styled-icons/boxicons-regular/CheckCircle';
import { Trash } from '@styled-icons/bootstrap/Trash';

export const Container = styled.section`
  padding: 16px 24px;
  background-color: #efefef;

  header > span {
    font-size: 1rem;
    font-family: ${({ theme }) => theme.fonts.workSans};
    color: ${({ theme }) => theme.colors.grayDark3};
  }

  .ant-table-selection {
    display: flex;
    justify-content: center;
  }

  .ant-table-thead > tr > th.ant-table-cell {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark};
  }
`;

export const ContainerErrors = styled.div`
  /* display: flex;
  flex: auto;
  border: 0.125rem solid #c74a34;
  border-radius: 0.25rem;
  font-size: 1rem;
  flex-direction: column;
  align-items: flex-start;
  padding: 1.5rem 1rem 1.5rem;
  gap: 1rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark3};

  & > span > span.danger {
    color: #c74a34;
    font-size: 1rem;
    font-weight: 600;
  } */
`;

export const MenuTable = styled.div`
  display: flex;
  justify-content: flex-end;
  flex: auto;
  font-size: 1rem;
  padding: 8px;
  gap: 10px;
  background: #fff;
  border-radius: 4px;
  margin-bottom: 16px;

  & > span > span.danger {
    color: #c74a34;
    font-size: 1rem;
    font-weight: 600;
  }

  button {
    height: 48px;
    padding: 0 12px;
  }
`;

export const ContainerChipsAdded = styled.div`
  font-size: 0.875rem;
  font-family: ${({ theme }) => theme.fonts.workSans};
  color: ${({ theme }) => theme.colors.grayDark3};
  margin: 1rem 0rem;
`;

export const SearchedHeader = styled.header`
  /* display: flex;
  padding-bottom: 1rem;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
  flex-wrap: wrap;
  font-size: 0.875rem;

  & > span {
    font-weight: 600;
    display: inline-block;
    width: 100%;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      width: unset;
    }

    & > span.added {
      color: ${({ theme }) => theme.colors.green};
      margin-right: 0.25rem;
    }

    & > span.non-identified {
      color: ${({ theme }) => theme.colors.red};
      margin-right: 0.25rem;
    }
  }

  & > div.divider {
    display: none;
    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      display: unset;
    }

    margin: 0 0.5rem;
    border-right: 0.1rem solid rgba(0, 0, 0, 1);
    height: 0.875rem;
    position: relative;
    top: 0.4rem;
    width: 0px;
  } */
`;

export const SearchedItens = styled.ul`
  list-style-type: none;
  max-height: 45vh;
  overflow-y: auto;

  & > li {
    padding: 0.5rem;
    color: ${({ theme }) => theme.colors.graySubTitle};
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: opacity 0.5s;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      padding: 1rem;
    }

    & > div.sku-container {
      display: flex;
      flex-direction: column;

      justify-content: space-between;
      max-width: 80%;

      & > span {
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 0.5rem;
        min-width: 5rem;
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: row;
        align-items: center;

        & > span {
          margin-bottom: unset;
          margin-right: 1rem;
        }
      }
    }

    &.non-identified > span,
    &.non-identified > button {
      opacity: 0.4;
    }

    &:not(:last-child) {
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }

    & > div.actions {
      display: flex;
      justify-content: flex-end;
      min-width: 20%;
      align-items: center;

      & > button {
        width: 1.5rem;
        border: none;
        background: none;
        outline: none;
        cursor: pointer;
      }
    }

    &.remove-element {
      opacity: 0;
    }
  }
`;

export const CloseCircleIcon = styled(CloseCircle)`
  color: ${({ theme }) => theme.colors.red};
  width: 1.5rem;
  margin-left: 0.5rem;
`;

export const CheckCircleIcon = styled(CheckCircle)`
  color: ${({ theme }) => theme.colors.green};
  width: 1.5rem;
  margin-left: 0.5rem;
`;

export const TrashIcon = styled(Trash)`
  color: ${({ theme }) => theme.colors.blue};
  width: 1.5rem;
  margin-left: 0.5rem;
`;

export const ProductNotFoundAlertContainer = styled.div`
  padding: 0.75rem 1rem;
  width: fit-content;

  display: flex;
  gap: 0.75rem;

  border-radius: 4px;
  border: solid 2px #ff7703;

  background-color: #ffffe6;
  color: ${({ theme }) => theme.colors.grayDark4};
`;

export const HeaderContainer = styled.span`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
`;

export const Title = styled.span`
  font-size: 1.5rem;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  line-height: 32px;
  color: ${({ theme }) => theme.colors.grayDark3};
`;

export const Subtitle = styled.span`
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.grayDark4};
`;
